import demandeInfoAbonnementApi from '@/api/abonnement/demande-infos-abonnement.api'

const getDefaultState = () => {
  return {
    hasDemandeRecente: null,
  }
}

const module = {
  namespaced: true,

  state: getDefaultState(),

  getters: {
    hasDemandeRecente (state) {
      return state.hasDemandeRecente
    },
  },
  mutations: {
    SET_HAS_DEMANDE_RECENTE (state, hasDemandeRecente) {
      state.hasDemandeRecente = hasDemandeRecente
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    createDemandeInformationAbonnement ({ rootGetters, commit }, fonctionnalite) {
      const numtiers = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return demandeInfoAbonnementApi.createDemandeInformationAbonnement(numtiers, fonctionnalite)
        .then(() => {
          commit('SET_HAS_DEMANDE_RECENTE', true)
        })
    },
    getHasDemandeRecente ({ rootGetters, commit }) {
      const numtiers = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return demandeInfoAbonnementApi.getHasDemandeRecente(numtiers)
        .then(result => {
          commit('SET_HAS_DEMANDE_RECENTE', result)
        })
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
